import { Box, Typography, Button, Stack  } from "@mui/material"

export const ExploreTourToolTip = ({ step, primaryProps, skipProps, backProps, tooltipProps, size, index, image, end, role, view, setter, p_name, featureName }) => (
        <Box {...tooltipProps} sx={{ p: 3, borderRadius: 2, position: "relative", width: view === "" ? 400 : 320 , bgcolor: "#fff"}}>
            {index > 0 ?
                <Box>
                    <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <Typography sx={{ fontSize: 18, fontWeight: 800, color: "primary.main"}}>{step.title}</Typography>
                        {/* <Typography sx={{ fontSize: 18, fontWeight: 500 }}>{index} of {size - 1}</Typography> */}
                    </Box>
                
                    <Typography sx={{ fontSize: 14, fontWeight: 500, my: 2,}}>{step.content}</Typography>
                    
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Button {...skipProps} onClick={()=>{end(featureName, p_name); setter()}} sx={{textTransform: "none" }}>Skip</Button>
                        <Button {...primaryProps} variant="contained" sx={{ bgcolor: "#0A7C3E", color: "#fff", borderRadius: 5, px: 3, textTransform: "none", }}>{(index) === size - 1 ? "Got it" : "Next"}</Button>
                    </Box>
                </Box>
            :
                <Stack sx={{justifyContent: 'center', borderRadius: 8, gap: 2}}>
                    <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", gap: 3, width: '100%'}}>
                        <Stack height='100%' width='100%' alignItems='center' justifyContent='center'>
                            <Stack gap={3} bgcolor='#fff' width='100%'>
                                <Box component="img" src={image} sx={{borderRadius: 4, width: 200, margin: "auto"}}/>
                                {/* <Box component="img" src={pos_welcome} sx={{borderRadius: 4}}/> */}
                                <Stack gap={2}>
                                    <Typography textAlign="center" fontSize={view === "" ? 22 : 16} fontWeight={800}>Welcome to Point of Sale!</Typography>
                                    <Typography sx={{fontSize: view === "" ? 14 : 12}}>
                                        The POS system provides strong, dependable features that keep your operations running smoothly. 
                                        It ensures that every part of your business from sales to inventory works seamlessly together to deliver optimal results.
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Box>
                    <Box sx={{display: "flex", gap: 1}}>
                        <Button {...primaryProps} fullWidth variant="contained" sx={{ bgcolor: "#0A7C3E", color: "#fff", borderRadius: 1, py: 1, textTransform: "none", boxShadow: "none", "&:hover":{boxShadow: "none", bgcolor: '#0A7C3E'} }}>Let's Start</Button>
                        <Button {...skipProps} onClick={()=>{end(featureName, p_name); setter()}} fullWidth variant="contained" sx={{ bgcolor: "#ffffffff", color: "#000000ff", borderRadius: 1, py: 1, textTransform: "none", boxShadow: "none", "&:hover":{boxShadow: "none", bgcolor: "#fff"} }}>Skip</Button>
                    </Box>
                </Stack>
            }
        </Box>
    );